/* BB 2026 — wishlist.
   Saved items live in localStorage on the visitor's own device: handle and
   variant only. Everything the drawer shows is fetched from the storefront
   when it opens, so a saved item can never quote a price that has moved.
   There is no account sync — that needs customer accounts and a server. */
(function () {
  if (window.__bbWishReady) return;
  window.__bbWishReady = true;

  var KEY = 'bb-wishlist';
  var cache = {};   // handle -> product JSON, for this page view

  /* ---------- store ---------- */
  function read() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(raw) ? raw.filter(function (i) { return i && i.h; }) : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    sync();
  }
  function has(handle) {
    return read().some(function (i) { return i.h === handle; });
  }
  function toggle(handle, variant) {
    var list = read();
    var at = list.findIndex(function (i) { return i.h === handle; });
    if (at > -1) { list.splice(at, 1); } else { list.unshift({ h: handle, v: variant }); }
    write(list);
    return at === -1;
  }
  function remove(handle) {
    write(read().filter(function (i) { return i.h !== handle; }));
  }

  /* ---------- money ---------- */
  // Shopify's own format string, so the drawer prints prices the way the rest
  // of the store does without hard-coding a currency.
  function money(cents) {
    var fmt = window.BBMoneyFormat || '${{amount}}';
    function withDelims(num, precision, thousands, decimal) {
      var n = (num / 100).toFixed(precision);
      var parts = n.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts.join(parts[1] ? decimal : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, name) {
      switch (name) {
        case 'amount_no_decimals':                     return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator':            return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':return withDelims(cents, 0, '.', ',');
        default:                                       return withDelims(cents, 2, ',', '.');
      }
    });
  }

  /* ---------- the hearts and the badge ---------- */
  function sync() {
    var list = read();
    document.querySelectorAll('[data-bb-wish]').forEach(function (btn) {
      var on = list.some(function (i) { return i.h === btn.dataset.wishHandle; });
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-label', on ? 'Saved to wishlist' : 'Save to wishlist');
    });
    document.querySelectorAll('[data-bb-wish-dot]').forEach(function (dot) {
      dot.hidden = list.length === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bb-wish]');
    if (btn) {
      // The heart usually sits inside the gallery link, so stop the navigation.
      e.preventDefault();
      e.stopPropagation();
      toggle(btn.dataset.wishHandle, btn.dataset.wishVariant);
      return;
    }
    if (e.target.closest('[data-bb-wish-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-bb-wish-close]')) { close(); return; }

    var rm = e.target.closest('[data-bb-wish-remove]');
    if (rm) { remove(rm.dataset.bbWishRemove); render(); return; }

    var add = e.target.closest('[data-bb-wish-add]');
    if (add) { addToCart(add); return; }
  });

  /* ---------- the drawer ---------- */
  var scrollY = 0;
  function el() { return document.querySelector('[data-bb-wishd]'); }

  function open() {
    var d = el();
    if (!d) return;
    d.hidden = false;
    scrollY = window.scrollY;
    document.body.style.top = -scrollY + 'px';
    document.body.classList.add('bb-wishd-open');
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    render();
  }
  function close() {
    var d = el();
    if (!d) return;
    d.classList.remove('is-open');
    document.body.classList.remove('bb-wishd-open');
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
    setTimeout(function () { d.hidden = true; }, 260);
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && el() && !el().hidden) close();
  });

  function product(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { cache[handle] = p; return p; })
      .catch(function () { return null; });
  }

  function render() {
    var d = el();
    if (!d) return;
    var list = read();
    var ul = d.querySelector('[data-bb-wish-list]');
    var empty = d.querySelector('[data-bb-wish-empty]');
    var count = d.querySelector('[data-bb-wish-count]');

    count.textContent = list.length ? list.length + (list.length === 1 ? ' item' : ' items') : '';
    empty.hidden = list.length > 0;
    if (!list.length) { ul.innerHTML = ''; return; }

    Promise.all(list.map(function (i) { return product(i.h); })).then(function (products) {
      ul.innerHTML = '';
      products.forEach(function (p, n) {
        // A product that has been deleted or unpublished quietly drops out.
        if (!p) { remove(list[n].h); return; }
        var wanted = String(list[n].v);
        var v = p.variants.filter(function (x) { return String(x.id) === wanted; })[0] || p.variants[0];
        var img = (v && v.featured_image && v.featured_image.url) || p.featured_image || '';

        var li = document.createElement('li');
        li.className = 'bb-wishd__item';
        li.innerHTML =
          '<a class="bb-wishd__thumb" href="/products/' + p.handle + '">' +
            (img ? '<img src="' + img.split('?')[0] + '?width=320" alt="" loading="lazy">' : '') +
          '</a>' +
          '<div class="bb-wishd__meta">' +
            '<a class="bb-wishd__name" href="/products/' + p.handle + '">' + p.title + '</a>' +
            (v && v.title && v.title !== 'Default Title'
              ? '<span class="bb-wishd__variant">' + v.title + '</span>' : '') +
            '<span class="bb-wishd__price">' + money(v ? v.price : p.price) + '</span>' +
            '<span class="bb-wishd__acts">' +
              (v && v.available
                ? '<button type="button" class="bb-wishd__act" data-bb-wish-add="' + v.id + '">Add to cart</button>'
                : '<span class="bb-wishd__act is-out">Sold out</span>') +
              '<button type="button" class="bb-wishd__act bb-wishd__act--quiet" data-bb-wish-remove="' + p.handle + '">Remove</button>' +
            '</span>' +
          '</div>';
        ul.appendChild(li);
      });
    });
  }

  /* ---------- add to cart ---------- */
  function addToCart(btn) {
    var id = btn.dataset.bbWishAdd;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js', { credentials: 'same-origin' }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        btn.textContent = 'Added';
        // The header count is server-rendered, so nudge it by hand.
        document.querySelectorAll('[data-header-cart-count]').forEach(function (e) {
          e.textContent = '(' + cart.item_count + ')';
        });
        // The theme keeps its own copy of the cart and renders the drawer from
        // it; without this it would open showing the cart as it was on load.
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('bb:cart:updated', { detail: { cart: cart, source: 'bb-wishlist' } }));
        // Adding something and seeing nothing happen reads as a broken button,
        // so hand the visitor over to the cart they just added to.
        setTimeout(function () {
          btn.textContent = label;
          btn.disabled = false;
          close();
          showCart();
        }, 550);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        btn.disabled = false;
      });
  }

  // The theme's cart drawer, opened the way the theme opens it. There are two
  // toggles in the header — desktop and mobile — and only one is ever laid out.
  function showCart() {
    var toggles = document.querySelectorAll('[data-drawer-toggle="drawer-cart"]');
    for (var i = 0; i < toggles.length; i++) {
      if (toggles[i].offsetParent !== null) { toggles[i].click(); return; }
    }
  }

  /* ---------- boot ---------- */
  // Another tab is the same wishlist.
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    sync();
    if (el() && !el().hidden) render();
  });
  if (document.readyState !== 'loading') sync();
  document.addEventListener('DOMContentLoaded', sync);
  document.addEventListener('shopify:section:load', sync);
})();
